export const rline_user = (role_identifier) =>
  ["hosts", "store_manager"].includes(role_identifier);
